export const SET_USER = "SET_USER";
export const SIGN_UP = "SIGN_UP";
export const LOGIN_EMAIL = "LOGIN_EMAIL";
export const SET_FILES = "SET_FILES";
export const SET_LABELS = "SET_LABELS";
export const SET_SELECTED_LABELS = "SET_SELECTED_LABELS";
export const SET_PATH = "SET_PATH";
export const SET_FILE_PATH = "SET_FILE_PATH";
export const SET_FILE_STRUCTURE = "SET_FILE_STRUCTURE";
export const SET_COMPANY_LIST = "SET_COMPANY_LIST";
export const SET_UPDATED_COMPANY_LIST = "SET_UPDATED_COMPANY_LIST";
export const SET_BILLING_PLAN = "SET_BILLING_PLAN";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const SET_COMPANY_ID = "SET_COMPANY_ID";
export const SET_LABEL_STATUS = "SET_LABEL_STATUS";
export const SET_EMAIL_UPLOAD_STATUS = "SET_EMAIL_UPLOAD_STATUS";
export const BREADCRUMB_CHANGE = "BREADCRUMB_CHANGE";
export const SET_FOLDER_PATH = "SET_FOLDER_PATH";
export const SET_CHART_ACCOUNTS = "SET_CHART_ACCOUNTS";
export const SET_CSV_DATA = "SET_CSV_DATA";
export const SET_CURRENT_PERIOD = "SET_CURRENT_PERIOD";
export const SET_COMPARE_PERIOD = "SET_COMPARE_PERIOD";
export const SET_FILTER_PERIOD = "SET_FILTER_PERIOD";
export const SET_GRID_VIEW = "SET_GRID_VIEW";
export const SET_BANKSTATEMENT_LINE_ITEMS = "SET_BANKSTATEMENT_LINE_ITEMS";
export const RESET_BANKSTATEMENT_LINE_ITEMS = "RESET_BANKSTATEMENT_LINE_ITEMS";
export const DOCUMENT_TYPE_CHANGE = "DOCUMENT_TYPE_CHANGE";
export const SET_TABLE_FILTERS = "SET_TABLE_FILTERS";
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const SET_LINKS_SIDEBAR_OPEN = "SET_LINKS_SIDEBAR_OPEN";
